import React from 'react';

import PropTypes from 'prop-types';

import PermissionIndicator from './PermissionIndicator';
import { optionShape } from '../helpers/propTypes';
import { Option, GroupHeader } from '../types';

type PermissionValueProps = {
  permission: { value?: string | number } | null;
  permissions?: (Option | GroupHeader)[];
  pillCount?: number;
  showGroupLabel?: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  disabled?: boolean;
};

const PermissionValue = ({
  permission = {},
  permissions = [],
  pillCount = 4,
  showGroupLabel,
  ...props
}: PermissionValueProps) => {
  const {
    pillValue = {},
    label,
    groupLabel,
    ...rest
  } = (permissions.find(
    (option) => option.value === permission?.value
  ) as Option) || {};
  const valueLabel = showGroupLabel ? groupLabel || label : label;
  const tooltip = showGroupLabel ? label : undefined;
  const pillClassName = new Array(pillCount).fill(1).reduce((pre, _, idx) => {
    pre[idx] =
      pillValue[idx] !== PermissionIndicator.PILL_TYPES.FULL
        ? 'PermissionValue__pill--gray'
        : '';
    return pre;
  }, {});

  return (
    <PermissionIndicator
      pillCount={pillCount}
      pillValue={pillValue}
      label={valueLabel}
      tooltip={tooltip}
      pillClassName={pillClassName}
      {...rest}
      {...props}
    />
  );
};

PermissionValue.displayName = 'PermissionValue';

PermissionValue.propTypes = {
  /**
   * style for the component
   */
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  /**
   * Permission option
   */
  permission: optionShape,
  /**
   * Props of the SelectBox
   */
  permissions: PropTypes.arrayOf(optionShape),
  /**
   * The pill count
   */
  pillCount: PropTypes.number,
  /**
   * When display group label (if have)
   * instead of the selected option label
   */
  showGroupLabel: PropTypes.bool,
  /**
   * Whether the component is disabled
   */
  disabled: PropTypes.bool,
};

export default PermissionValue;
